<template>
        <div class="wrapper">    
 

            <div class="pt-3 pl-2">
                
                <h5 class="title">{{ColecaoNome}}   </h5>
                <small>{{ColecaoDescricao}}   </small>
            </div>

        </div>

</template>

<script>
    export default {
        props: {
            CarImg: {
                type: String,
            },
            ColecaoNome: {
                type: String,
            },           
            ColecaoDescricao: {
                type: String,
            },
            CarId: {
                type:Number
            },
          
        },
        computed: {
           
        },
    }
</script>

<style lang="css" scoped>
.wrapper{
    display:flex;
    flex-direction: row;
}

.div-title {
    width:30%;
}

.title{
    color:var(--main-red-black);
}

.car_image {
    width: 25%;
    height: 5rem;
    vertical-align: middle;
    border-style: none;
    -o-object-fit:contain;
    object-fit: contain;
    background: transparent;
    padding-top:3%;
}


</style>